module.exports = __webpack_public_path__ + "static/media/15(3).de1103a5.jpg";